// src/app/app-routing.module.ts
import { NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';
import { LandingPage } from './pages/landing/landing.page';


const routes: Routes = [
  { path: '',        redirectTo: 'landing', pathMatch: 'full' },
  { path: 'landing', component: LandingPage },

  { path: 'login',     loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule) },
  { path: 'cadastrar', loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupPageModule) },

  // bucket do seu layout privado
  { 
    path: 'app',
    loadChildren: () =>
      import('./routing-priv/routing-priv.module').then(m => m.RoutingPrivModule)
  },
  

  { path: '**', redirectTo: 'landing' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading }) ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
